var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "header",
      {
        staticClass: "header header-homepage has-waves__bottom",
        attrs: { id: "vue-header" },
      },
      [
        _c("div", { staticClass: "header-background" }, [
          _c("div", { staticClass: "desktopView" }, [
            _vm.desktopVideo
              ? _c(
                  "video",
                  {
                    ref: "desktopVideo",
                    attrs: {
                      id: "headervideo",
                      muted: "",
                      autoplay: "",
                      loop: "",
                      playsinline: "",
                    },
                    domProps: { muted: true },
                  },
                  _vm._l(_vm.desktopVideo, function (vid) {
                    return _c("source", {
                      attrs: { src: vid.Url, type: vid.Format },
                    })
                  }),
                  0
                )
              : _vm.desktopPicture
              ? _c("picture", { ref: "desktopPicture" }, [
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1600px)",
                      "data-srcset":
                        _vm.desktopPicture.Url +
                        "&anchor=center&mode=crop&width=1920&height=788&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.desktopPicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1600px)",
                      "data-srcset":
                        _vm.desktopPicture.Url +
                        "&anchor=center&mode=crop&width=1400&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.desktopPicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1400px)",
                      "data-srcset":
                        _vm.desktopPicture.Url +
                        "&anchor=center&mode=crop&width=1200&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.desktopPicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1200px)",
                      "data-srcset":
                        _vm.desktopPicture.Url +
                        "&anchor=center&mode=crop&width=1000&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.desktopPicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1000px)",
                      "data-srcset":
                        _vm.desktopPicture.Url +
                        "&anchor=center&mode=crop&width=800&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.desktopPicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 800px)",
                      "data-srcset":
                        _vm.desktopPicture.Url +
                        "&anchor=center&mode=crop&width=600&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.desktopPicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 600px)",
                      "data-srcset":
                        _vm.desktopPicture.Url +
                        "&anchor=center&mode=crop&width=600&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.desktopPicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "lazyload",
                    attrs: {
                      width: "1920",
                      height: "520",
                      src: _vm.desktopPicture.Url + "&rnd=132435981408400000",
                      "data-src":
                        _vm.desktopPicture.Url + "&rnd=132435981408400000",
                      "data-sizes": "auto",
                    },
                  }),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mobileView h-100" }, [
            _vm.mobileVideo
              ? _c(
                  "video",
                  {
                    ref: "mobileVideo",
                    staticClass: "w-100 h-100 object-fit-cover",
                    attrs: {
                      id: "mobilevideo",
                      muted: "",
                      autoplay: "",
                      loop: "",
                      playsinline: "",
                    },
                    domProps: { muted: true },
                  },
                  _vm._l(_vm.mobileVideo, function (vid) {
                    return _c("source", {
                      attrs: { src: vid.Url, type: vid.Format },
                    })
                  }),
                  0
                )
              : _vm.mobilePicture
              ? _c("picture", { ref: "mobilePicture" }, [
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1600px)",
                      "data-srcset":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=1920&height=788&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.mobilePicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1600px)",
                      "data-srcset":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=1400&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.mobilePicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1400px)",
                      "data-srcset":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=1200&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.mobilePicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1200px)",
                      "data-srcset":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=1000&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.mobilePicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 1000px)",
                      "data-srcset":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=800&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.mobilePicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 800px)",
                      "data-srcset":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=600&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.mobilePicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _c("source", {
                    attrs: {
                      media: "(min-width: 600px)",
                      "data-srcset":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=600&height=400&format=webp&quality=90&rnd=132435981408400000",
                      type: _vm.mobilePicture.Format,
                    },
                  }),
                  _vm._v(" "),
                  _vm.mobilePicture.Url
                    ? _c("source", {
                        attrs: {
                          media: "(max-width: 600px)",
                          "data-srcset":
                            _vm.mobilePicture.UrlMobile +
                            "&anchor=center&mode=crop&height=400&format=webp&rnd=132449089073870000",
                          type: _vm.mobilePicture.Format,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "lazyload img-fluid",
                    attrs: {
                      width: "1920",
                      height: "520",
                      src:
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=1920&quality=100&rnd=132435981408400000",
                      "data-src":
                        _vm.mobilePicture.Url +
                        "&anchor=center&mode=crop&width=1920&rnd=132435981408400000",
                      "data-sizes": "auto",
                    },
                  }),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _vm.mobileVideo || _vm.desktopVideo
          ? _c("div", { staticClass: "header-video-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "random-border-radius",
                  class: [_vm.videoPaused ? "d-flex" : "d-none"],
                  attrs: { id: "play-button" },
                  on: { click: _vm.play },
                },
                [
                  _c("svg", { staticClass: "icon icon-play" }, [
                    _c("use", { attrs: { "xlink:href": "#icon-play" } }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "random-border-radius",
                  class: [_vm.videoPaused ? "d-none" : "d-flex"],
                  attrs: { id: "pause-button" },
                  on: { click: _vm.pause },
                },
                [
                  _c("svg", { staticClass: "icon icon-pause" }, [
                    _c("use", { attrs: { "xlink:href": "#icon-pause" } }),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "header-content" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }